import { createFileRoute } from "@tanstack/react-router";
import GeoAustralia from "@/pages/GeoAustralia";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "Can I hire a GHL automation expert in the AEST timezone?",
    answer:
      "Yes. Marjohn is a Philippines-based GoHighLevel automation expert with AEST/AWST timezone alignment for Australian agencies, giving you real-time overlap with your local team without local Australian rates.",
  },
  {
    question:
      "Why hire a GHL automation expert from the Philippines for Australia?",
    answer:
      "Hiring from the Philippines gives Australian agencies senior-grade GoHighLevel engineering at a fraction of local rates, with direct contractor engagement, AEST/AWST timezone overlap, and no agency markups.",
  },
  {
    question:
      "How much does it cost to hire a GHL automation expert for Australia?",
    answer:
      "Engagements are scoped per project or retainer. Marjohn works as a remote contractor paid via low-fee cross-border transfers such as Wise. Book a free strategy call to receive a custom scope and quote.",
  },
  {
    question: "What timezone overlap do you offer with Australia?",
    answer:
      "Marjohn offers strategic overlap with both AEST (Sydney/Melbourne) and AWST (Perth) business hours, so Australian agencies get real-time collaboration during their working day.",
  },
];

export const Route = createFileRoute("/ghl-automation-expert-australia")({
  head: () =>
    buildPageHead({
      title: "GHL Automation Expert Australia | Marjohn Robillo",
      description:
        "Hire an elite GHL Automation Expert from the Philippines for your Australian agency. Perfect AEST/AWST timezone alignment and direct partnership.",
      path: "/ghl-automation-expert-australia",
      keywords:
        "GHL automation expert Australia, GoHighLevel Australia, AEST timezone VA, Australian agency automation, CRM specialist Australia, Philippines VA Australia",
      hreflang: [
        {
          hreflang: "en-US",
          href: "https://marjohnrobillo.me/hire-technical-va-usa",
        },
        {
          hreflang: "en-GB",
          href: "https://marjohnrobillo.me/revops-specialist-uk",
        },
        {
          hreflang: "en-AU",
          href: "https://marjohnrobillo.me/ghl-automation-expert-australia",
        },
        { hreflang: "x-default", href: "https://marjohnrobillo.me/" },
      ],
      schema: [
        serviceSchema({
          name: "GHL Automation Expert for Australian Agencies",
          description:
            "GoHighLevel automation engineering with AEST/AWST timezone alignment for Australian agencies.",
          path: "/ghl-automation-expert-australia",
          serviceType: [
            "GoHighLevel Automation",
            "CRM Architecture",
            "Revenue Operations",
          ],
          areaServed: ["Australia", "New Zealand"],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          {
            name: "GHL Automation Expert Australia",
            path: "/ghl-automation-expert-australia",
          },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: GeoAustralia,
});
